// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { TableColumn } from 'src/app/_interfaces/advance-search/tableColumn';

export const ADVANCED_SEARCH_TABLE_COLUMN_CONFIG: TableColumn[] = [
  {
    key: 'serialNumber',
    translationKey: 'label.serialNumber',
    sortable: true,
  },
  {
    key: 'materialNumber',
    translationKey: 'label.systemMaterialNumber',
    sortable: true,
  },
  {
    key: 'customerName',
    translationKey: 'label.customerName',
    sortable: true,
  },
  { key: 'country', translationKey: 'label.country', sortable: true },
  { key: 'city', translationKey: 'label.city', sortable: true },
  {
    key: 'functionalLocation',
    translationKey: 'label.functionalLocation',
    sortable: true,
  },
  {
    key: 'isSupported',
    translationKey: 'label.supportStatus',
    sortable: true,
  },
  {
    key: 'equipmentActive',
    translationKey: 'label.equipmentStatus',
    sortable: true,
  },
  {
    key: 'modalityName',
    translationKey: 'label.input.modalityId',
    sortable: true,
  },
  { key: 'productName', translationKey: 'label.productName', sortable: true },
  {
    key: 'softwareVersion',
    translationKey: 'label.softwareVersion',
    sortable: true,
  },
  { key: 'equipmentId', translationKey: 'label.equipmentId', sortable: true },
  {
    key: 'equipmentTechId',
    translationKey: 'label.equipmentTechId',
    sortable: true,
  },
];
